<script setup lang="ts">
import { ref, computed } from "vue";
import { onClickOutside } from "@vueuse/core";

import type { UrlAlias } from "@Modules/urls/Data/Models/UrlAliasFactory";

//
// Props
interface Props {
    urlAlias: UrlAlias;
    confirmed: () => void;
}

const props = defineProps<Props>();

//
// Emit
interface Events {
    (e: "close"): void;
}

const emit = defineEmits<Events>();

//
// Data
const modalRef = ref<HTMLElement | null>(null);


//
// Computed
const alias = computed(() => props.urlAlias.mainAlias());
const aliasDisplay = computed(() => alias.value ? `${alias.value.domain}/${alias.value.alias}` : "");

//
// Methods
function close() {
    emit("close");
}

function confirm() {
    props.confirmed();
    emit("close");
}

//
// Watchers
onClickOutside(modalRef, () => close);
</script>

<template>
  <div class="modal d-block">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div
        ref="modalRef"
        class="modal-content"
      >
        <div class="flex-center-between pt-4 pr-4 pb-2 pl-4">
          <h6 class="mb-0">
            Delete TinyURL
          </h6>
          <button
            type="button"
            class="_close_modal close-2"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body px-4 text-center text-break">
          <p class="mb-1 font-weight-semibold _alias_name">
            Are you sure you want to delete "{{ aliasDisplay }}"?
          </p>
          <span class="text-gray-500">
            Once deleted, the TinyURL will no longer redirect to the destination URL
            and will produce an error page. This action cannot be reversed.
          </span>
        </div>
        <div class="flex-center-center flex-wrap px-4 pb-4">
          <button
            type="button"
            class="_cancel btn btn-block--xs-only rounded-xl px-3 px-md-4 px-lg-5 m-1 btn-outline-blue"
            @click="close"
          >
            Cancel
          </button>
          <button
            type="button"
            class="_confirm btn btn-block--xs-only rounded-xl px-3 px-md-4 px-lg-5 m-1 btn-danger"
            @click="confirm"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
